/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.inventario': 'Inventario',
  'sidebar.gestionproducto': 'Gestión producto',
  'gestionproducto.medido.dimensiones': 'Cm',
  'gestionproducto.medido.peso': 'Kg',
  'gestionproducto.agregarProducto': 'Crear producto',
  'gestionproducto.editarProducto': 'Editar producto',
  'gestionproducto.Abreviatura': 'Nombre corto',
  'gestionproducto.CodigoBarras': 'Código barras',
  'gestionproducto.DescripcionItem': 'Descripción ítem',
  'gestionproducto.Modelo': 'Modelo',
  'gestionproducto.Estado': 'Estado',
  'gestionproducto.Contenedor': 'Contenedor',
  'gestionproducto.Importado': 'Importado',
  'gestionproducto.Lotes': 'Maneja lotes',
  'gestionproducto.ManejaPeso': 'Maneja Peso',
  'gestionproducto.Seriado': 'Seriado',
  'gestionproducto.Serialconsecutivo': 'Serial consecutivo',
  'gestionproducto.DescripcionUnidad': 'Descripción unidad',
  'gestionproducto.FabricanteDescripcion': 'Fabricante descripción',
  'gestionproducto.FamiliaDescripcion': 'Familia descripción',
  'gestionproducto.ClasificacionDescripcion': 'Clasificación descripción',
  'gestionproducto.Familia': 'Familia',
  'gestionproducto.Unidad': 'Unidad',
  'gestionproducto.Clasificacion': 'Clasificación',
  'gestionproducto.ClaseTecnica': 'Clase técnica',
  'gestionproducto.Referencia': 'Referencia',
  'gestionproducto.Marca': 'Marca',
  'gestionproducto.Fabricante': 'Fabricante',
  'gestionproducto.Ancho': 'Ancho',
  'gestionproducto.Alto': 'Alto',
  'gestionproducto.Peso': 'Peso',
  'gestionproducto.Largo': 'Largo',
  'gestionproducto.verImagen': 'Imágenes',
  'gestionproducto.RfId': 'RFID',
  'gestionproducto.FIFO': 'FIFO',
  'gestionproducto.FEFO': 'FEFO',
  'gestionproducto.Valor': 'Costo',
  'gestionproducto.Valor.Monto': '$',
  'gestionproducto.itemSeleccionado': 'Ýtem seleccionado',
  'gestionproducto.titulo.agregarUnidades': 'Agregar unidad',
  'gestionproducto.titulo.agregarPropiedades': 'Agregar propiedades',
  'gestionproducto.titulo.editarUnidades': 'Editar unidad',
  'gestionproducto.titulo.editarPropiedades': 'Editar propiedades',
  'gestionproducto.titulo.datosProducto': 'Datos producto',
  'gestionproducto.titulo.dimensionesProducto': 'Dimensiones producto',
  'gestionproducto.titulo.configuracionProducto': 'Configuración producto',
  'gestionproducto.titulo.unidadesDeConversion': 'Unidades de conversión',
  'gestionproducto.titulo.propiedadesProducto': 'Propiedades de Producto',
  'gestionproducto.alerta.seleccionarUnidad': 'Por favor seleccione una unidad para agregar las unidades de conversión',
  'gestionproducto.alerta.medidasInvalidas': 'Las dimensiones ingresadas deben ser mayores a 0',
  'gestionproducto.alerta.codigoBarrasInvalido':
    'El código de barras ingresado no corresponde con el producto seleccionado',
  'gestionproducto.Propiedades.ProductoTipoPropiedadDescripcion': 'Tipo Propiedad',
  'gestionproducto.Propiedades.ProductoPropiedadTexto': 'Propiedad Texto',
  'gestionproducto.Propiedades.ProductoPropiedadCantidad': 'Cantidad',
  'gestionproducto.Propiedades.ProductoPropiedadEstado': 'Estado',
  'gestionproducto.camposSerialManejaPeso':'Si esta marcada la casilla de Maneja Peso también debe seleccionar la casilla de Seriado o Seriado Consecutivo.',
  'gestionproducto.CodigoClasificacion': 'Código Clasificación',
  'gestionproducto.SinSaldo':'Sin saldo',
  // componente imagenes
  'gestionproducto.seleccionarItem': 'Selección ítem',
  'gestionproducto.rotarDerecha': 'Rotar 90°',
  'gestionproducto.rotarIzquierda': 'Rotar -90°',
  'gestionproducto.alerta.limiteImagenes': 'Ha excedido el máximo de imágenes',
  'gestionproducto.alerta.archivoInvalido': 'El tipo de archivo ingresado es inválido',
  'gestionproducto.alerta.eliminarImagen': '¿Está seguro que desea eliminar la imagen?',
  'gestionproducto.productoSinImagenes': 'No hay imágenes cargadas',
  'gestionproducto.tamañoImagenes': 'Se recomienda usar una imagen cuadrada',
  'gestionproducto.nombreArchivoExcel': 'Productos',
  'gestionproducto.FamiliaInactivo':'Registro de familia está inactivo, seleccione uno nuevo.',
  'gestionproducto.ClasificacionInactivo':'Registro de clasificación está inactivo, seleccione uno nuevo.',
  'gestionproducto.ClaseTecnicaInactivo':'Registro de clase técnica está inactivo, seleccione uno nuevo.',
  'gestionproducto.ReferenciaInactivo':'Registro de referencia está inactivo, seleccione uno nuevo.',
  'gestionproducto.MarcaInactivo':'Registro de marca está inactivo, seleccione uno nuevo.',
  'gestionproducto.FabricanteInactivo':'Registro de fabricante está inactivo, seleccione uno nuevo.',
  'gestionproducto.UnidadInactivo':'Registro de unidad está inactivo, seleccione uno nuevo.',
  'gestionproducto.CodigoEmpresa':'Código producto',
  'gestionproducto.InventarioCritico':'Inventario Critico',
  'gestionproducto.Manejapeso':'Maneja peso',
  // ModalCostos  
  'gestionproducto.TituloCostos':'Costos',
  'gestionproducto.Bodega':'Bodega',
  'gestionproducto.Producto':'Producto',
  'gestionproducto.Costo': 'Costo',
  'gestionproducto.CostoPromedio': 'Costo Promedio',
  'gestionproducto.CostoMAUC': 'Costo MAUC',
};
